import { logger } from '../utils/logger'
import { useAuthenticatedApi } from '../infrastructure/authbymsal'
import { FetchApiRequest } from '../infrastructure/api/types/fetch.api.type'

// Ceci est une forme d'adapteur, mais pas un véritable adaptateur.
// Il s'agit d'une fonction qui utilise une fonction existante pour effectuer une tâche spécifique.
// Un véritable adaptateur implémenterait une interface spécifique pour une classe ou un objet spécifique.

export const useFetchApi = () => {
  const authenticatedApi = useAuthenticatedApi()

  const fetchApi = async <T>(url: string, options?: FetchApiRequest, returnType?: string) => {
    try {
      const response = await authenticatedApi(url, options)
      if (!response) {
        return
      }
      return returnType === 'blob' ? response.blob() : (response.json() as Promise<T>)
    } catch (error) {
      logger.error(`fetchApi.useFetchApi Error fetching data from ${url}: ${error}`)
      throw error
    }
  }

  return fetchApi
}
